var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_8229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6012 25.6032C31.4582 19.7461 31.4582 10.25 25.6012 4.39294C19.7442 -1.4641 10.248 -1.4641 4.39099 4.39294C-1.46604 10.25 -1.46604 19.7461 4.39099 25.6032C10.248 31.4602 19.7442 31.4602 25.6012 25.6032Z",
    fill: "#00A3E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0232 5.07568C19.0616 5.07568 22.1983 8.50026 22.1983 12.4624C22.1983 16.4246 15.2772 24.9247 15.0232 24.9247C14.7692 24.9247 7.80151 16.4246 7.80151 12.4624C7.80151 8.50026 10.9848 5.07568 15.0232 5.07568Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1037 16.6107C17.4065 16.6107 19.2733 14.7439 19.2733 12.4411C19.2733 10.1383 17.4065 8.27148 15.1037 8.27148C12.8009 8.27148 10.9341 10.1383 10.9341 12.4411C10.9341 14.7439 12.8009 16.6107 15.1037 16.6107Z",
    stroke: "white",
    strokeMiterlimit: 22.93
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_8229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.1a3da03250b66af4345d88daaae505a4.svg";
export { ForwardRef as ReactComponent };